import { Checkbox, CheckboxProps } from '@mui/material';
import { useSelection } from '../../hooks/useSelection';

interface CustomCheckboxProps<T> extends Omit<CheckboxProps, 'sx' | 'checked' | 'onChange' | 'indeterminate'> {
  size?: 'small' | 'medium';
  item?: T;
  items: T[];
  getItemId: (item: T) => string | number;
}

export const CustomCheckbox = <T,>({ 
  size = 'small',
  item,
  items,
  getItemId,
  ...props 
}: CustomCheckboxProps<T>) => {
  const { isSelected, toggleSelection, toggleAll, isAllSelected, isSomeSelected } = useSelection({
    items,
    getItemId
  });

  const checkboxProps = item ? {
    checked: isSelected(item),
    onChange: () => toggleSelection(item)
  } : {
    checked: isAllSelected,
    onChange: toggleAll,
    indeterminate: isSomeSelected
  };
  
  return (
    <Checkbox
      {...props}
      {...checkboxProps}
      size={size}
    />
  );
}; 